import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Removes "Certified", "CertifiedUFA" prefixes and "website" from team/club names
 */
export function cleanTeamName(name: string): string {
  return name
    .replace(/^CertifiedUFA\s+/i, '')
    .replace(/^Certified\s+/i, '')
    .replace(/\bwebsite\b/gi, '')
    .replace(/\s+/g, ' ')
    .trim();
}
